import React from 'react';

const HeaderMin = () => {
    const pictures = '/images/';
    return (
        <header id="header-min-div">
            <div className="container">
                <div className="row header-min-small-center">
                    <div> <a href="\1" class="col-md-2 d-md-block"><img src={pictures + "header-min-logo.svg"} height="40px" /></a></div>
                    <div className="d-flex col-md-6 d-md-block header-min-small-center">
                        <div>
                            <div><strong>The #1 company for office machines and furniture for over 30 years.</strong>
                                <br />43 Redcliffe St., St. John's, Antigua & Barbuda</div>
                        </div>
                    </div>
                    <div id="header-min-contact-info" className="d-flex col-md-4 d-md-block  flex-column">
                        <div className="d-flex header-min-small-center">
                            <div className="mr-1"><img src={pictures + "phone.svg"} height="17px"></img></div>
                            <div >(268)562-4839</div>
                        </div>
                        <div className="d-flex header-min-small-center">
                            <div className="mr-1"><img src={pictures + "email.svg"} height="17px"></img></div>
                            <div><a href="mailto:sales@bssantigua.com">sales@bssantigua.com</a></div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default HeaderMin;